import RouteHistoryListItem from './components/RouteHistoryListItem'
import css from './routesHistoryWidget.module.css'
import useRoutesHistoryWidget from './useRoutesHistoryWidget'
import { useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import equipmentAtom from '@/pages/Equipment/atoms/equipment.atom'
import routesHistoryWidgetConstants from './routesHistoryWidget.constants'
import routesHistoryWidgetUtils from './routesHistoryWidget.utils'
import SkeletonRouteHistoryListItem from './components/SkeletonRouteHistoryListItem'
import EmptyPlaceholder from '@/shared/Common/EmptyPlaceholder'
import useOrganizationUsers from '@/pages/Users/hooks/useOrganizationUsers'
import userAtom from '@/pages/User/user.atom'

const RoutesHistoryWidget = () => {
  const equipmentList = useRecoilValue(equipmentAtom).items
  const userState = useRecoilValue(userAtom)
  const { loading: usersLoading, users } = useOrganizationUsers(userState.organizationId)
  const { routesStats, loading } = useRoutesHistoryWidget()
  const navigate = useNavigate()

  const renderSkeletonList = () => {
    return Array.from({ length: routesHistoryWidgetConstants.maxRoutesShown }).map((_, index) => (
      <SkeletonRouteHistoryListItem key={index} />
    ))
  }

  const renderRouteList = () => {
    if (loading || usersLoading) return renderSkeletonList()
    if (!routesStats.length) {
      return (
        <div className="flex-lines center height100">
          <EmptyPlaceholder inscription="Список пуст" />
        </div>
      )
    }
    const slicedRoutesStats = routesStats.slice(0, routesHistoryWidgetConstants.maxRoutesShown)

    return routesHistoryWidgetUtils
      .mapHistoryRoutesToTitles(slicedRoutesStats, equipmentList, users)
      .map((routeItem) => (
        <RouteHistoryListItem
          key={routeItem.routeName}
          routeHistory={routeItem}
          onClick={() => navigate(routeItem.routeName)}
        />
      ))
  }

  return (
    <div className={css.wrapper}>
      <h2 style={{ padding: '6px 20px' }} className="text-heading-4">
        Недавно посещенные
      </h2>
      <div className={css.equipmentListWrapper}>{renderRouteList()}</div>
    </div>
  )
}

export default RoutesHistoryWidget
